import classNames from 'classnames'
import { ReactElement } from 'react'

import { Loader } from 'core-components/library/loader'

import styles from './SimpleResultContent.module.scss'

interface IProps {
  success: boolean
  message: string
  children?: ReactElement | null
  isLoading?: boolean
  loadingText?: string
  showMessage?: boolean
}

export const SimpleResultContent = ({
  success,
  message,
  children,
  isLoading,
  loadingText,
  showMessage,
}: IProps) => {
  let resultToRender = <div className={styles.message}>{message}</div>
  if (isLoading) {
    resultToRender = <div className={styles.message}>{loadingText || 'Processing...'}</div>
  } else if (children) {
    resultToRender = (
      <div className={styles.message}>
        {showMessage && message ? <div className={styles.messageWrapper}>{message}</div> : null}
        {children}
      </div>
    )
  }

  return (
    <div className={styles.container}>
      {isLoading ? (
        <Loader dimension={{ width: 72, height: 72 }} />
      ) : (
        <i
          className={`kbase ${
            success ? 'kbase-check-circle-alt' : 'kbase-close-circle-alt'
          } ${classNames(styles.status, success ? styles.success : styles.failure)}`}
        />
      )}
      {resultToRender}
    </div>
  )
}
